/**
 * Created by Ning Jiang on 10/11/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {IScreenViewConfig, ScreenView} from "@nolimitcity/slot-game/bin/core/screen/ScreenView";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {Orientation} from "@nolimitcity/slot-game/bin/core/stage/Orientation";
import {IResizeData} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/core/text/TextStyleOptions";
import {Translation} from "@nolimitcity/slot-game/bin/core/translation/Translation";
import {UserAgent} from "@nolimitcity/slot-game/bin/core/useragent/UserAgent";
import {TimelineLite, TweenLite} from "gsap";
import {CCTNineSliceButton} from "../../component/CCTNineSliceButton";
import {CreepyCarnivalTwoGameConfig} from "../../CreepyCarnivalTwoGameConfig";
import {CreepyCarnivalTwoSoundConfig} from "../../CreepyCarnivalTwoSoundConfig";
import {CreepyCarnivalTwoStrings} from "../../CreepyCarnivalTwoStrings";
import {CreepyCarnivalTwoParsedGameData} from "../../server/data/CreepyCarnivalTwoParsedGameData";
import {CreepyCarnivalBulbsEvent} from "../../utils/CCTwoBulb";
import {CCTwoInitialWPEvents} from "../../winpresentation/initial/CreepyCarnivalTwoInitialWPController";
import {Currency} from "@nolimitcity/slot-game/bin/core/balance/Currency";

export interface ICreepyCarnivalTwoFreespinIntroViewConfig extends IScreenViewConfig {
    featureNameTexture?:string,
    amountTexture?:string,
}

export class CreepyCarnivalTwoStarSpinIntroView extends ScreenView {

    private _creepyCarnivalconfig:ICreepyCarnivalTwoFreespinIntroViewConfig;
    private _container:PIXI.Container;
    private _introBanner:PIXI.Sprite;
    // private _timerBG: PIXI.Sprite;
    private _slotApi:any;
    private _aveBetValue:number;
    private _mt:PIXI.Container = new PIXI.Container();
    private playedBet:number[] = [];

    private _asPromoisedStyle:TextStyleOptions = {
        fontSize : "12px",
        fill : "#95DC8A",
        fontWeight : '400',
        fontFamily : 'Arial'
    };
    private _starSpinStyle:TextStyleOptions = {
        fontSize : "16px",
        fill : "#BFF6C1",
        fontWeight : '600',
        fontFamily : 'Arial'
    };
    private _highValueStyle:TextStyleOptions = {
        fontSize : "18px",
        fill : "#8DD787",
        fontFamily : 'Arial'
    };

    private _promiseText:PIXI.Text;
    private _starSpin:PIXI.Text;
    private _starSpinBet:PIXI.Text;
    private _starSpinBetValue:PIXI.Text;
    private _highValue:PIXI.Text;
    private _introBannerContainer:PIXI.Container;
    private _timelineIntroBanner:TimelineLite;
    private _specialSymbolsArray:any = [];
    private _isResourcesLoaded:boolean = false;
    private _isInit:boolean = false;

    constructor(config:ICreepyCarnivalTwoFreespinIntroViewConfig, autoClose:boolean = false) {
        super(config, autoClose);
        this._slotApi = SlotGame.api;
        this._creepyCarnivalconfig = config;
        EventHandler.addEventListener(this, CCTwoInitialWPEvents.CHANGE_BET_FOR_STAR_SPIN, (event:GameEvent) => this.changeBetForStarSpin(event.params[0].newBet));
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected createGameGraphics():PIXI.DisplayObject {
        this._container = new PIXI.Container();
        const introBannerContainer:PIXI.Container = new PIXI.Container();
        const starSpinContainer:PIXI.Container = new PIXI.Container();
        this._introBanner = new PIXI.Sprite(GameResources.getTextures("curtain_star")[0]);
        this._introBanner.anchor.set(0.5);
        this._introBanner.scale.set(0.999, 0.997);
        this._introBanner.position.set(2, -5);

        // this._timerBG = new PIXI.Sprite(GameResources.getTextures("assets/timerBG")[0]);
        // this._timerBG.anchor.set(0.5, 0.5);
        // this._timerBG.scale.set(1, 0.8);
        // this._timerBG.position.set(0, 222);
        // this._timerBG.alpha = 0;

        introBannerContainer.addChild(this._introBanner);

        this._promiseText = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.AS_PROMISED)} `, this._asPromoisedStyle);
        this._promiseText.anchor.set(0.5);
        this._promiseText.position.set(0, 60);
        introBannerContainer.addChild(this._promiseText);

        this._starSpin = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.FREE_STAR_SPIN)} `, this._starSpinStyle);
        this._starSpin.anchor.set(0.5);
        this._starSpin.position.set(0, 80);
        this._starSpin.skew.set(0, -0.02);
        introBannerContainer.addChild(this._starSpin);

        this._highValue = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.HIGH_VALUE_SYMBOLS)} `, this._highValueStyle);
        this._highValue.anchor.set(0.5);
        this._highValue.scale.set(0.75, 0.75);
        this._highValue.position.set(0, 100);
        this._highValue.skew.set(0, 0.03);
        introBannerContainer.addChild(this._highValue);

        introBannerContainer.addChild(this._mt);
        this._starSpinBet = new PIXI.Text(` ${Translation.translate(CreepyCarnivalTwoStrings.STAR_SPIN)+`${Translation.translate('Bet')+" :"}`} ` , this._starSpinStyle);
        this._starSpinBet.anchor.set(0.5,0.5);
        this._starSpinBet.position.set(-25, 150);

        this._starSpinBetValue = new PIXI.Text("" , this._starSpinStyle);
        this._starSpinBetValue.anchor.set(0.5);
        this._starSpinBetValue.position.set(5, 150);
        //starSpinContainer.position.set(0, 150);
        introBannerContainer.addChild(this._starSpinBet);
        introBannerContainer.addChild(this._starSpinBetValue);
        introBannerContainer.addChild(starSpinContainer);
        starSpinContainer.name = "starSpinContainer";
        //starSpinContainer.pivot.set(0.5);


        this._container.addChild(introBannerContainer);
        // this._container.addChild(this._timerBG);
        this._introBannerContainer = introBannerContainer;

        let bannerMask = new PIXI.Graphics();
        bannerMask.beginFill(0x000000, 0.8);
        bannerMask.drawRect(-385, -260, 800, 700);
        bannerMask.endFill();
        this._container.addChild(bannerMask);
        introBannerContainer.mask = bannerMask;
        return this._container;
    }

    protected createButton():CCTNineSliceButton {
        const text:string = Translation.translate(this._config.buttonText ? this._config.buttonText : "CONTINUE");
        const textStyle:TextStyleOptions = this.getScaledButtonTextStyle();
        const button = new CCTNineSliceButton(() => this.onButtonClick(), ` ${text} `, textStyle, this._config.buttonBackgroundConfig);
        button.enabled = false;
        button.visible = false;
        return button;
    }

    protected onResizeGameGraphics(resizeData:IResizeData):void {
        this._container.position.set(this._screenWidth * 0.5, this._screenHeight * 0.5);

        // this._timerBG.width = this._autoCloseTimer.width + 50;

        if(resizeData.orientation === Orientation.PORTRAIT) {
            this._container.x = (this._container.x - 2);
            this._container.y = (this._container.y + 12);
        } else if(UserAgent.isMobile) {
            this._container.x = (this._container.x - 2);
            this._container.y = (this._container.y);
        } else {
            this._container.x = (this._container.x);
            this._container.y = (this._container.y);
        }
    }

    protected changeBetForStarSpin(data:number):void {
        this._aveBetValue = data;
    }

    protected startPresentation(data?:ParsedServerData, onShowComplete?:() => void):void {
        EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : "STAR_SPIN"}));
        EventHandler.dispatchEvent(new GameEvent(CCTwoInitialWPEvents.DISPLAY_STAR_SPIN_LOGO));
        this.playIntroBannerAnimation(onShowComplete);
    }

    protected playIntroBannerAnimation(onShowComplete?:() => void) {
        this._button.visible = false;
        // this._autoCloseTimer.visible = false;\
        let symbol = Currency.getPlayerCurrency().symbol;
        const _currencySymbol = symbol ? symbol : "";

         if(this._aveBetValue) {
             this._starSpinBetValue.text = this._aveBetValue.toString();
             if(Currency.getPlayerCurrency().before) {
                 this._starSpinBetValue.text = " " + _currencySymbol + " " + this._starSpinBetValue.text;
             } else {
                 this._starSpinBetValue.text = " " + this._starSpinBetValue.text + " " + _currencySymbol;
             }
             this._starSpinBetValue.x = (this._starSpinBet.x+this._starSpinBet.width/2)+this._starSpinBetValue.width/2;
         }
        if(!this._timelineIntroBanner) {
            const timeline:TimelineLite = new TimelineLite({paused : true});
            timeline.add(() => {
                this._introBannerContainer.visible = true;
                SlotGame.sound.playEffect(CreepyCarnivalTwoSoundConfig.instance.SS_SCREEN);
            });
            timeline.add([
                TweenLite.fromTo(this._introBannerContainer, 1, {y : -400}, {
                    y : -30,
                    onComplete : () => {
                        // this._autoCloseTimer.visible = true;
                        this._button.visible = true;
                    }
                }),
            ]);
            timeline.add(() => {
                if(onShowComplete) {
                    onShowComplete();
                    // this._timerBG.alpha = 1;
                }
            });
            this._timelineIntroBanner = timeline;
        }
        this._timelineIntroBanner.play(0);

    }

    protected stopPresentation(closeCallback?:() => void):void {
        const timeline:TimelineLite = new TimelineLite({paused : true});
        this._button.visible = false;
        // this._autoCloseTimer.visible = false;
        // this._timerBG.alpha = 0;
        timeline.add([
            TweenLite.fromTo(this._introBannerContainer, 0.5, {y : -30}, {y : -600}),
        ]);
        timeline.add(() => {
                this.fadeSymbols();
                EventHandler.dispatchEvent(new GameEvent(CreepyCarnivalBulbsEvent.SHOW_STAR_SPIN_BULBS));
            },
        );
        timeline.add(() => {
            this._introBannerContainer.visible = false;
            this._introBannerContainer.y = -400;
            this._timelineIntroBanner.kill();
            this.emptyArray();
            super.stopPresentation(closeCallback);
        }, 2.5);
        timeline.play(0);
    }

    protected initAnimations():void {
        this._isResourcesLoaded = true;

        super.initAnimations();
        this.createSpecialSymbols();
    }

    private fadeSymbols():void {
        for(let k:number = 0; k < CreepyCarnivalTwoGameConfig.instance.REELS_NUM; k++) {
            Reels.getSymbol(k, 0) && Reels.getSymbol(k, 0)!.changeState({
                state : GameConfig.instance.SYMBOL_STATES.noWin!,
                fadeInDuration : .1
            });
        }
    }

    private emptyArray():void {
        this._mt.removeChildren();
    }

    private onGameDataParsed(data:CreepyCarnivalTwoParsedGameData):void {
        this.emptyArray();

        if(data.getSpecialSymbolsArray.length) {
            this._specialSymbolsArray = data.getSpecialSymbolsArray;

            this.createSpecialSymbols();
        }
    }

    private onInitDataParsed(data:CreepyCarnivalTwoParsedGameData):void {
        this._isInit = true;

        this.onGameDataParsed(data);
    }

    private createSpecialSymbols():void {
        if(!this._isResourcesLoaded || !this._isInit || this._specialSymbolsArray.length === 0) {
            return;
        }

        let child, text, x, y, j = 0;

        this.playedBet = [];
        for(let i = 0; i < this._specialSymbolsArray.length; i++) {
            let sym:string = this._specialSymbolsArray[i].symbol;
            child = new PIXI.Sprite(GameResources.getTextures("assets/" + sym.toLowerCase() + "_collect")[0]);
            if(i < 7) {
                x = -280;
                y = -105;
            } else {
                j = (j === 7) ? 0 : j;
                x = -234;
                y = -11;
            }
            child.position.set(x + (93 * j), y);
            child.anchor.set(0.5);
            const noDecimals = this._specialSymbolsArray[i].betValue >= 10 && this._specialSymbolsArray[i].betValue.toFixed(2).endsWith('00');
            if(noDecimals) {
                this.playedBet.push(this._specialSymbolsArray[i].betValue.toFixed(0));
            } else {
                this.playedBet.push(this._specialSymbolsArray[i].betValue.toFixed(2));
            }
            text = new PIXI.Text(this.playedBet[i].toString(), {
                fontFamily : 'Insane Rodeo Bold',
                fontSize : 18,
                fill : 0xffffff,
                align : 'center'
            });
            text.anchor.set(0.5, 0.5);
            text.position.set(x + (93 * j), y - 50);
            j++;
            this._mt.addChild(child);
            this._mt.addChild(text);
        }
    }
}